import { Component, Input, ViewEncapsulation, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { element } from 'protractor';

import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
//import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName} from '@angular/forms';
import { ValidationFormsService } from './validation-forms.service';
import { ValidatorFn, ValidationErrors } from '@angular/forms';
import { ToasterComponent, ToasterPosition } from '@coreui/angular';
import { AppToastComponent as ToastComp } from '../../../services/shared-service/toast-simple/toast.component'
import { HttpService } from '../../../services/http-service/http.service'
import { ModalDirective } from 'ngx-bootstrap/modal';

import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../../../services/storege-service/storage.service';
import * as moment from 'moment';
import { ToolService } from '../../../services/tool/tool.service';

@Component({
  //selector: 'app-toasters',
  templateUrl: './basic-forms.component.html',
  styleUrls: ["../../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css",],
  //encapsulation: ViewEncapsulation.None,
  providers: [ ValidationFormsService ]
})


export class BasicFormsComponent {


  minDate = new Date(2017, 5, 10);
  maxDate = new Date(2022, 9, 15);

  bsValue: Date = new Date();

// Timepicker

  public isEnabled: boolean = true;


  public mfData? : object = {};
  public courts?;
  public users?;
  public daysArray?:Array<{nameEn: string}> = [];
  reoccurDays: string;
  isUpdate: boolean = false;
  dbFunction?: string;
  disabledId: string;
  courtId: string;
  description: string;
  startTime: string;
  endTime: string;
  startDate: string;
  endDate: string;
  price30min: string;
  price60min: string;
  price90min: string;
  price120min: string;
  status: string;
  public facilityId = '';
  public isLoading = false;

  public responseData?;
  public dbActiveData? = Array();

  isError: boolean = false;

  simpleForm: FormGroup;
  submitted = false;
  formErrors: any;

  //private toasterService: ToasterService;
  //public toasterconfig: ToasterConfig = new ToasterConfig({tapToDismiss: true, timeout: 5000});
  
  @ViewChild(ToastComp) toastComp: ToastComp;
  @ViewChild('dangerModal', {static: false}) public dangerModal: ModalDirective;

  public paddingStyle: Object = { 'padding-right': '20px'};


  constructor(
    private router: Router, 
    private http: HttpClient, 
    public route: ActivatedRoute,
    private fb: FormBuilder,
    public vf: ValidationFormsService, 
    public httpService: HttpService,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private storageSrv: StorageService,
    public toolService: ToolService,
    ) {
    //if (localStorage.getItem('currentUser') === null) {this.router.navigateByUrl('/login');}
    if (localStorage.getItem('lang') === "ar") {
      //this.toasterconfig = new ToasterConfig({tapToDismiss: true, timeout: 5000, positionClass: 'toast-top-left'});
    }
    //this.toasterService = toasterService;
    this.formErrors = this.vf.errorMessages;
    this.facilityId = this.storageSrv.getFacilityId();

    if(this.router.getCurrentNavigation().extras.state?.createData == null)
    {
      this.isUpdate = true;
      this.mfData = this.router.getCurrentNavigation().extras.state?.data;
      this.disabledId = this.mfData['id'];
      this.courtId = this.mfData['courtIds']?.split(',');
      this.description = this.mfData['description'];
      this.startTime = this.mfData['startTime'] != null ? new Date(this.mfData['start_date'].replace(/-/g, "/") + " " + this.mfData['startTime'].replace(/-/g, "/")) : this.mfData['startTime'];
      this.endTime = this.mfData['endTime'] != null ? new Date(this.mfData['end_date'].replace(/-/g, "/") + " " + this.mfData['endTime'].replace(/-/g, "/")) : this.mfData['endTime'];
      this.startDate = this.mfData['start_date'] != null ? new Date(this.mfData['start_date'].replace(/-/g, "/")) : this.mfData['start_date'];
      this.endDate = this.mfData['end_date'] != null ? new Date(this.mfData['end_date'].replace(/-/g, "/")) : this.mfData['end_date'];
      this.reoccurDays = this.mfData['reoccurDays']?.split(',');
      this.price30min = this.mfData['price30min'];
      this.price60min = this.mfData['price60min'];
      this.price90min = this.mfData['price90min'];
      this.price120min = this.mfData['price120min'];
      this.status = this.mfData['status'];
    }
    else
    {
      this.disabledId = '';
      this.courtId = '';
      this.description = '';
      this.startTime = '';
      this.endTime = '';
      this.startDate = '';
      this.endDate = '';
      this.reoccurDays = '';
      this.price30min = '';
      this.price60min = '';
      this.price90min = '';
      this.price120min = '';
      this.status = '';
    }
    this.loadDays();
    this.loadCourts(this.facilityId);
    this.createForm();
  }

  isCollapsed: boolean = false;
  iconCollapse: string = 'icon-arrow-up';

  @Input() message : string;
  messages: string[] = [];
  updatedData = this.mfData;

  // Validators.pattern('^[0-9]{4}[\/][1-9]|1[012][\/][0-9]{2}$')]
  createForm() {
    this.simpleForm = this.fb.group({
      description: [this.description, [Validators.required]],
      courtId: [this.courtId, [Validators.required]],
      startTime: [this.startTime, [Validators.required]],
      endTime: [this.endTime, [Validators.required]],
      startDate: [this.startDate, [Validators.required]],
      endDate: [this.endDate, [Validators.required]],
      reoccurDays: [this.reoccurDays, [Validators.required]],
      price30min: [this.price30min, [Validators.required]],
      price60min: [this.price60min, [Validators.required]],
      price90min: [this.price90min, [Validators.required]],
      price120min: [this.price120min, [Validators.required]],
      status: [this.status],
    }, { });
  }
  get f() { return this.simpleForm.controls; }


  async showSuccess(msg) {

    await this.toastr.success(msg, 'Success');

    if (this.isUpdate && !this.isError)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });;
      });  
    }
    else if (!this.isUpdate && this.isError == false)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });;
      });  
    }
  }

  showError(msg) {
    //this.toasterService.pop('error', 'Error', msg);
  }


  public findInvalidControls() {
    const invalid = [];
    const controls = this.simpleForm.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
}


saveDisabled = () => {
  return new Promise<any>(async (resolve, reject) => {
    this.isLoading = true;
    let formattedStartDate = (moment(new Date(this.f['startDate'].value))).format('YYYY-MM-DD');
    let formattedEndDate = (moment(new Date(this.f['endDate'].value))).format('YYYY-MM-DD');
    let formattedStartTime = new Date(this.f['startTime'].value).toTimeString().toString().substr(0, 8);
    let formattedEndTime = new Date(this.f['endTime'].value).toTimeString().toString().substr(0, 8);
    var startDateTime = formattedStartDate + ' ' + formattedStartTime;
    var endDateTime = formattedEndDate + ' ' + formattedEndTime;
    var courtIds = this.f['courtId'].value.toString();
    var reoccurDays = this.f['reoccurDays'].value?.toString();
    
    const fields = {
      disabledId: this.mfData['id'],
      facilityId: this.facilityId,
      courtIds: courtIds,
      description: this.f['description'].value,
      startTime: formattedStartTime,
      endTime: formattedEndTime,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      reoccurDays: reoccurDays,
      price30min: this.f['price30min'].value,
      price60min: this.f['price60min'].value,
      price90min: this.f['price90min'].value,
      price120min: this.f['price120min'].value,
      status: this.f['status'].value,
    };
    if (this.isUpdate) 
    {
      this.localInterfaceSrv.updateDisabled(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('Disabled Updated');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
      })
      .finally(() => this.isLoading = false);
    } 
    else 
    {
      this.localInterfaceSrv.addDisabled(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('Disabled Added');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
      })
      .finally(() => this.isLoading = false);
    }
  });
}

  async delay(ms: number) {
    //await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>this.toolService.showConsoleLog("fired"));
}

  collapsed(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  updateData(name: string): void {
    this.updateData['nameEn'] = name;
  }
 

  expanded(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.iconCollapse = this.isCollapsed ? 'icon-arrow-down' : 'icon-arrow-up';
  }
  deleteDisabled = (disabledId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        disabledId: disabledId
      };
      this.localInterfaceSrv.deleteDisabled(disabledId)
      .then(async res => {
        resolve(res);
        this.toastr.success("Disabled Removed", "Success");
        this.dangerModal.hide();
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
        });
        //window.location.reload()
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
        this.dangerModal.hide();
      })
      .finally(() => this.isLoading = false);
    });
  }
  loadCourts = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getCourts(facilityId)
      .then(res => {
        this.responseData = Object.values(res);
        this.responseData[0].forEach(item => {
          if (item.status=='A')
          {
            const newObj = item;
            this.dbActiveData.push(newObj);
          }
        });
        this.courts = this.dbActiveData;
        this.courts.offers = res.offers;
        this.courts.content = this.dbActiveData;
        //this.courts = res;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.desc, "Error");
      })
      .finally(() => this.isLoading = false);
    });
  }
  loadDays = () => {
    this.daysArray.push({
      nameEn: 'saturday'
    },
    {
      nameEn: 'sunday'
    },
    {
      nameEn: 'monday'
    },
    {
      nameEn: 'tuesday'
    },
    {
      nameEn: 'wednesday'
    },
    {
      nameEn: 'thursday'
    },
    {
      nameEn: 'friday'
    });
  }
}
